const marketingInputsCCData: string[] = ["elf"];

export const shouldEnableMarketingInputsCCData = (company: string): boolean => {
  return marketingInputsCCData.includes(company);
};
